import * as React from "react";

export interface RuntimeDataContextValue {
  cache: Record<string, Record<string, unknown>[]>;
  getData: (resource: string) => Record<string, unknown>[] | undefined;
  refresh: (resource: string) => Promise<void>;
  create: (resource: string, variables: Record<string, unknown>) => Promise<Record<string, unknown>>;
  update: (resource: string, id: string, variables: Record<string, unknown>) => Promise<Record<string, unknown>>;
  deleteOne: (resource: string, id: string) => Promise<Record<string, unknown>>;
}

export const RuntimeDataContext = React.createContext<RuntimeDataContextValue | null>(null);
